<template>
  <multipane-resizer-impl></multipane-resizer-impl>
</template>

<script>
import {MultipaneResizer} from "vue-multipane";

export default {
  name: "MultipaneResizer",
  components: {
    MultipaneResizerImpl: MultipaneResizer,
  },
}
</script>
